<template>
    <a-card title="Event">
        <a-list itemLayout="horizontal" :dataSource="events">
            <a-list-item slot="renderItem" slot-scope="item, index">
                <a-list-item-meta>
                    <div slot="title">
                        <a :href="'/send-freight/bookings/' + item.bookingId " style="color: black"><strong>Booking {{item.bookingId}}</strong></a>
                        <span style="float: right;font-size: 0.9rem;">{{item.time}}</span>
                    </div>
                    <div slot="description">
                        <div>{{item.description}}</div>
                    </div>
                </a-list-item-meta>
            </a-list-item>
        </a-list>
    </a-card>
</template>

<script>
    const events = [
        {
            bookingId: 110019,
            time: '5 Minutes ago',
            description: 'Picked up',
        },
        {
            bookingId: 110019,
            time: '15 Minutes ago',
            description: 'Delivered',
        },
        {
            bookingId: 110019,
            time: '4 Hours ago',
            description: 'Placed',
        },
        {
            bookingId: 110019,
            time: '2 days ago',
            description: 'Cancelled',
        },
    ];

    export default {
        name: "EventsDashboardSender",
        data () {
            return {
                events,
            };
        }
    }
</script>

<style scoped>

</style>